import React from 'react'
import { withPrefix } from 'gatsby'
import Accordion from '../../../accordion/accordion'
import './resolvamos-las-preguntas-frecuentes.css'
import { GTMEvents } from '../../../../lib/GTMevents'

const accordionData = [
  {
    title: '¿Qué es el programa AhorroYa!?',
    content: (
      <p>
        Es un programa a través del cual podrás ahorrar parte de tus consumos en
        establecimientos aliados. AhorroYa! no es un programa de descuentos.
      </p>
    ),
  },
  {
    title: '¿Cómo funciona el programa AhorroYa!?',
    content: (
      <p>
        Una parte de tus consumos en los establecimientos aliados los
        trasladamos a tu cuenta de aportes voluntarios sin fin previsional.
      </p>
    ),
  },
  {
    title: '¿Qué es una cuenta de aportes voluntarios sin fin previsional?',
    content: (
      <ul>
        <li>
          Es una cuenta independiente de tu fondo obligatorio, y genera la
          rentabilidad del tipo de fondo donde se encuentra.{' '}
          <span className="b">Prima AFP </span>
          enviará el estado de cuenta mensualmente vía email en donde se
          indicarán los aportes voluntarios derivados de tus consumos, y la
          rentabilidad obtenida.
        </li>
        <li>
          Puedes retirar el dinero las veces que quieras sin penalidades, a
          través de la{' '}
          <a
            href="https://miespacio.prima.com.pe/"
            target="_blank"
            alt="miespacio"
          >
            <b>web</b>
          </a>{' '}
          o{' '}
          <a
            href="https://play.google.com/store/apps/details?id=prima.android.splashscreentest&hl=es_PE&gl=US&pli=1"
            target="_blank"
          >
            <b>app</b>
          </a>{' '}
          de Prima AFP. El monto máximo para retiros por la web y app es de S/
          20,000.00. Para retirar cantidades mayores deberás registrar una
          solicitud de atención con nuestros ejecutivos a través de los canales
          antes mencionados.
        </li>
      </ul>
    ),
  },
  {
    title: '¿Cómo le hago seguimiento a mis aportes?',
    content: (
      <ul>
        <li>
          Todos los aportes generados en un mes estarán acreditados en la cuenta
          de aportes voluntarios sin fin previsional del cliente en la última
          semana del mes siguiente de realizados los consumos.
        </li>
        <li>
          Podrás hacer seguimiento desde nuestra{' '}
          <a
            href="https://miespacio.prima.com.pe/"
            target="_blank"
            alt="miespacio"
          >
            <b>web</b>
          </a>{' '}
          o{' '}
          <a
            href="https://play.google.com/store/apps/details?id=prima.android.splashscreentest&hl=es_PE&gl=US&pli=1"
            target="_blank"
          >
            <b>app</b>
          </a>
          .
        </li>
      </ul>
    ),
  },
  {
    title: '¿Cuál es la comisión y rentabilidad?',
    content: (
      <ul>
        <li>
          La cuenta de aportes voluntarios sin fin previsional esta afecta a la
          comisión de administración sobre el saldo administrado. Fondo 1: 0.10%
          mensual / Fondo 2: 0.12% mensual / Fondo 3: 0.16% mensual.
        </li>
        <li>
          Las ganancias de capital (rentabilidad) están afectas al 5% de
          impuesto a la renta.
        </li>
        <li>
          La cuenta de aportes voluntarios sin fin previsional es embargable.
        </li>
      </ul>
    ),
  },
  {
    title: 'Revisa los documentos informativos',
    content: (
      <ul>
        <li>
          <a
            target="_blank"
            href={withPrefix(
              '/files/2024/pdf/Cartilla_informativa_del_programa_AhorroYa.pdf'
            )}
          >
            <u>Cartilla informativa del programa AhorroYa!</u>
          </a>
        </li>
        <li>
          <a
            target="_blank"
            href={withPrefix('/aliados-comerciales/terminos-y-condiciones')}
          >
            <u>Términos y condiciones de inscripción al Programa AhorroYa!</u>
          </a>
        </li>
        <li>
          <a
            target="_blank"
            href={withPrefix(
              '/aliados-comerciales/terminos-y-condiciones-repsol'
            )}
          >
            <u>Condiciones específicas del programa AhorraYa!</u>
          </a>
        </li>
      </ul>
    ),
  },
]

const ResolvamosLasPreguntasFrecuentes = () => {
  return (
    <div className="ahorroYa__section-container">
      <h2 className="ahorroYa-section__title">¿Aún tienes dudas?</h2>
      <h3 className="ahorroYa-section__title ahorroYa-section__title--subtitle">
        Resolvamos las preguntas frecuentes
      </h3>
      <div className="box-accordion ahorroYa-questions__accordion">
        {accordionData.map(({ title, content }) => (
          <Accordion
            title={title}
            content={content}
            onOpen={() => GTMEvents.AhorroYaQuestionBtn(title)}
          />
        ))}
      </div>
    </div>
  )
}

export default ResolvamosLasPreguntasFrecuentes
